import { Get } from './common'

export const getLifts = async (accessToken) => {
    const url = process.env.REACT_APP_BASE_API_ADDRESS + "Lifts";
    return await Get(accessToken, url);
}